<div class="title-components">
    <h1>Riesgos y oportunidades</h1>
  </div>
  
  <!--&================== DIVIDER BUTONS LIBRARY ==================&-->
  <div class="divider-butons-M">
    <button
      [class.Is-Disabled]="
        !UserService.UserRoleGeneralIn([RolesGeneral.RisksOpportunities])
      "
      [disabled]="
        !UserService.UserRoleGeneralIn([RolesGeneral.RisksOpportunities])
      "
      (click)="OpenModalIsUpdate(false, null)"
      class="btn-icon-text"
    >
      <i class="fa-solid fa-plus"></i><span class="text">Agregar Riesgos y oportunidades</span>
    </button>
  </div>
  
  <ng-container *ngIf="All_RiskOpportunitiess.length > 0 && LoadPage; else Not_RiskOpportunities">
    <div class="Container-Card-RiskOpportunitiess">
      <div class="card-wrap" *ngFor="let RiskOpportunities of All_RiskOpportunitiess">
        <div class="card-header {{ Type_Extension_Class(RiskOpportunities.Extension) }}">
          <img
            src="./assets/Global/icon/{{ Type_Extension_Img(RiskOpportunities.Extension) }}"
            alt=""
            srcset=""
          />
          <div
            *ngIf="
              UserService.UserRoleGeneralIn([RolesGeneral.RisksOpportunities])
            "
            class="Options-RiskOpportunities"
          >
            <button
              (click)="OpenModalIsUpdate(true, RiskOpportunities)"
              class="Btn-Option button-square Upload-M"
            >
              <i class="fa-solid fa-upload"></i>
            </button>
            <button
              (click)="Delete_RiskOpportunities(RiskOpportunities)"
              class="Btn-Option button-square Delete-M"
            >
              <i class="fa-regular fa-trash-can"></i>
            </button>
          </div>
        </div>
        <div class="card-content">
          <h1 class="card-title">{{ Cut_Name(RiskOpportunities.Name) }}</h1>
          <p class="card-text">
            Descargue presionando sobre el boton descargar
          </p>
          <button
            (click)="Download_RiskOpportunities(RiskOpportunities)"
            class="card-btn {{ Type_Extension_Class(RiskOpportunities.Extension) }}"
          >
            Descargar
          </button>
        </div>
      </div>
    </div>
  </ng-container>
  
  <ng-template #Not_RiskOpportunities>
    <div class="Container-Preview container-global-components">
      <div class="Not-RiskOpportunities">
        <div class="Img-Not">
          <img src="./assets/Global/Ilustrations/Not-Annexes_See.png" alt="" />
        </div>
        <div class="Text-Not-RiskOpportunities">
          ¡Hola {{ NameUser() }}, aun no hay políticas de calidad para mostrar!
        </div>
      </div>
    </div>
  </ng-template>
  
  <!---===================== MODAL FOR ADD RiskOpportunitiesS =====================--->
  <section class="Modal-Global" id="ModalAddRiskOpportunities">
    <div class="wrapper">
      <div class="Pro-popup3 popup" id="Pro-popup3">
        <div class="Pro-inside3 popup-inside" id="Pro-inside3">
          <div class="Pro-backgrounds3 backgrounds">
            <div class="background"></div>
            <div class="background background2"></div>
            <div class="background background3"></div>
            <div class="background background4"></div>
            <div class="background background5"></div>
            <div class="background background6"></div>
          </div>
        </div>
        <div class="Pro-content3 content" id="Pro-content3">
          <button (click)="ToggleModalAddRiskOpportunities(false)" class="Btn-Close">
            <i class="fa-solid fa-xmark"></i>
          </button>
          <div class="Content-Top">
            <h2>{{ !IsUpdate ? "Cargar" : "Actualizar" }} Riesgos y oportunidades</h2>
          </div>
  
          <div class="Content-body">
            <div class="Container-Drop">
              <input
                #AddRiskOpportunities
                type="file"
                class="file"
                (dragover)="Load_File()"
                (dragleave)="Onload_File()"
                (change)="Load_Document_RiskOpportunities($event)"
              />
              <div class="Drag-Drop" id="Drag-Drop">
                <div class="Img">
                  <img src="./assets/Global/Ilustrations/Add_RiskOpportunities.jpg" alt="" />
                </div>
                <div class="Text">
                  Suelte su archivo aquí, o
                  <p>seleccione uno</p>
                </div>
                <div class="Subtitle">Soporta archivos PDF, PNG , PPTX ...</div>
              </div>
            </div>
  
            <div class="Container-Progress-RiskOpportunities" id="Container-Progress-RiskOpportunities">
              <div class="Title-Progress-RiskOpportunities">
                <span>Cargando ...</span>
                <div id="Icon-Done" class="Icon-Done">
                  <i class="fa-solid fa-check"></i>
                </div>
              </div>
              <div class="Container-Subtitle-RiskOpportunities">
                <div class="TextSubtitle">
                  <span id="TextProgress">0%</span>- un momento por favor
                </div>
              </div>
              <div class="Container-Progress-Bar-RiskOpportunities">
                <div class="Progress-Bar-RiskOpportunities" id="Progress-Bar-RiskOpportunities"></div>
              </div>
            </div>
          </div>
          <div class="Content-Bottom Modal-RiskOpportunities">
            <button
              (click)="ToggleModalAddRiskOpportunities(false)"
              class="Btn-LCancel-Form Btn-Close-Modal"
            >
              <span>Cerrar</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
  
  <!---===================== MODAL FOR DOWNLOAD PROGRESS BAR FIN =====================--->
  <section class="Modal-Global" id="ProgressModal">
    <div class="Content-DownloadTable">
      <div class="Tittle-Table">
        <h2>Descargando Riesgos y oportunidades...</h2>
      </div>
      <div class="Body-Table">
        <div class="Container-progress-bar">
          <span class="Progress-Bar-Table" id="Progress-Bar-Table"></span>
        </div>
      </div>
    </div>
  </section>
  
  <!---===================== MODAL FOR LOADER COMPONENT =====================--->
  <div class="Container-Loader-Global" id="Loader">
    <div class="loader loader-1">
      <div class="loader-outter"></div>
      <div class="loader-inner"></div>
    </div>
  </div>
  